import apiCall from "components/Api/api";
import { useAuth } from "provider/AuthContext";
import { useMasterContext } from "provider/MasterProvider";
import { useParksViewContext } from "provider/ParkViewProvider";
import React, { useEffect, useRef, useState } from "react";
import { Col, Form, Modal, Row } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";

const CorrectionModal = ({ handleClose }) => {
  const { parkSlug } = useParams();
  const { isLoggedIn } = useAuth();
  const { suggCorrToggle, parkDetail, parksViewDispatch } = useParksViewContext();
  const { suggestionCategory } = useMasterContext();
  const firstInputRef = useRef(null);
  const [suggestion, setSuggestion] = useState({
    master_suggestion_id: '',
    details: ''
  })
  const [errors, setErrors] = useState({
    master_suggestion_id: null,
    details: ''
  });

  useEffect(() => {
    if (suggCorrToggle && firstInputRef.current) {
      firstInputRef.current.focus(); // Focus the first input field when the modal opens
    }
  }, [suggCorrToggle]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSuggestion((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSubmit(e);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { master_suggestion_id, details } = suggestion;

    let hasError = false;
    const newErrors = {};

    if (!master_suggestion_id) {
      newErrors.master_suggestion_id = "Please select a category.";
      hasError = true;
    }

    if (!details) {
      newErrors.details = "Please provide details.";
      hasError = true;
    }

    setErrors(newErrors);

    if (hasError) return;

    try {
      const form = new FormData();
      form.append("master_suggestion_id", master_suggestion_id);
      form.append("details", details);

      const response = await apiCall({
        url: `park/${parkSlug}/suggestion`,
        method: "POST",
        data: form,
      });

      if (response.status !== 200) {
        throw new Error(`Unexpected status code: ${response.status}`);
      }

      const apiData = response.data;

      if (apiData?.errors && Object.keys(apiData.errors).length > 0) {
        const serverErrors = apiData.errors;

        // Set validation errors from backend
        setErrors((prevErrors) => {
          const updatedErrors = { ...prevErrors };
          Object.keys(serverErrors).forEach((key) => {
            updatedErrors[key] = serverErrors[key][0]; // Only show the first error
          });
          return updatedErrors;
        });

        return;
      }

      // Success: close modal and reset form
      parksViewDispatch({
        type: "SET_PARK_VIEW_CORRECTION_SUGGESTION_TOGGLE",
        payload: false,
      });

      setSuggestion({
        master_suggestion_id: '',
        details: ''
      });

      setErrors({
        master_suggestion_id: '',
        details: ''
      });

    } catch (error) {
      console.error("Error suggestion content:", error);
    }finally{
      
    }
  };


  return (
    <>
      <Modal show={suggCorrToggle} onHide={handleClose} centered restoreFocus={false}>
        <Modal.Header closeButton>
          <h1 className="modal-title fs-5">Suggest Correction</h1>
        </Modal.Header>
        <Modal.Body>

          {isLoggedIn ?
            <Form
              onSubmit={handleSubmit}
              onKeyDown={handleKeyDown}
            >
              <Modal.Body>
                <div className="modal_form">
                  <Row>
                    <Col xs={12}>
                      <h6
                        className="text-center"
                        style={{ fontWeight: "bolder" }}
                      >
                        {parkDetail?.title}
                      </h6>
                    </Col>

                    <Col xs={12} className="mb-2">
                      <Form.Group
                        className="selects w-100 d-flex flex-column mb-3"
                        controlId="reportReason"
                      >
                        <Form.Label className="Modal_label"> Select Category</Form.Label>
                        <Form.Select
                          name="master_suggestion_id"
                          className="form-select-lg"
                          aria-label="Large select example"
                          value={suggestion.master_suggestion_id}
                          onChange={handleChange}
                          ref={firstInputRef}
                        >
                          <option value="">Select Category</option>
                          {suggestionCategory?.map((item) => (
                            <option value={item?.value} key={item?.value}>{item?.label}</option>
                          ))}
                        </Form.Select>
                        {errors.master_suggestion_id && (
                          <p className="text-danger">{errors.master_suggestion_id}</p>
                        )}
                      </Form.Group>
                    </Col>

                    <Col xs={12} className="my-2">
                      <Form.Group controlId="reportDetail" className="textarea mb-3">
                        <Form.Label className="Modal_label">Details</Form.Label>
                        <Form.Control
                          as="textarea"
                          name="details"
                          placeholder="Write Reason in Detail"
                          value={suggestion.details}
                          onChange={handleChange}
                        />
                        {errors.details && (
                          <p className="text-danger">{errors.details}</p>
                        )}
                      </Form.Group>
                      {/* </div> */}
                    </Col>
                  </Row>
                  <Col xs={12}>
                    <div className="btn_report float-end">
                      <div className="btn_report_cance d-flex gap-2">
                        <button
                          type="button"
                          onClick={handleClose}
                          className="close_btns"
                          tabIndex="0"
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          variant="primary"
                          className="btns_submit"
                          tabIndex="0"
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </Col>
                </div>
              </Modal.Body>
            </Form>
            :
            <div id="modalContent">
              To suggest corrections, please{' '}
              <Link to={`/log-in?authclient=google&referrer=${encodeURIComponent(`/park/${parkSlug}`)}`}>
                log in
              </Link>
            </div>

          }

        </Modal.Body>
      </Modal>
    </>
  );
}

export default CorrectionModal;
